const formsNewsletter = document.querySelectorAll('.hoox-newsletter__form');

formsNewsletter.forEach(function (form) {
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    const parentFormContainer = form.closest('.hoox-newsletter__form-wrapper');
    const formNewsletterEmail = form.querySelector('.js-newsletter-email');
    const formButtonNewsletter = form.querySelector('.js-newsletter-button');
    const klaviyoId = form.closest('.hoox-newsletter-klaviyo-id-holder')?.dataset.klaviyoId;
    const newsletterInputValue = formNewsletterEmail.value;

    if (isEmailValid(newsletterInputValue)) {
      fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
        method: 'POST',
        headers: {
          accept: 'application/json, text/plain, */*',
          'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
        },
        body: new URLSearchParams({ g: klaviyoId, email: newsletterInputValue }),
      })
        .then(function (response) {
          if (response.ok) {
            formButtonNewsletter.disabled = false;
            formNewsletterEmail.value = '';
            parentFormContainer.classList.add('success');

            formsNewsletter.forEach(function (otherForm) {
              if (otherForm !== form) {
                const otherParent = otherForm.closest('.hoox-newsletter__form-wrapper');
                otherParent.classList.add('submitted');
              }
            });
          } else {
            formNewsletterEmail.value = '';
            formButtonNewsletter.disabled = true;
            parentFormContainer.classList.remove('success');
            parentFormContainer.classList.add('error');
          }
        })
        .catch(function (error) {
          formNewsletterEmail.value = '';
          formButtonNewsletter.disabled = true;
          parentFormContainer.classList.add('error');
        });
    } else {
      formNewsletterEmail.value = '';
      formButtonNewsletter.disabled = true;
      parentFormContainer.classList.remove('success');
      parentFormContainer.classList.add('error');
    }
  });
});

function isEmailValid(email) {
  const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  return regex.test(email);
}




